import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import { fetchAddMealList, addMealToNutritionPlan, toggleFavourite, clearMessage } from '../../../redux/slices/customer/mealPlanSlice';
import { Link } from 'react-router-dom';
import '../../../global.css';
import { calculateCalories, formatNumber } from '../../../utils';
import { useParams, useNavigate } from 'react-router-dom';
import Pagination from '../../../components/common/Pagination';

const AddMeal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addMealListCurrentPage, addMealList, addMealListTotalPages, newly_added_nutrition_plans_meal } = useSelector((state) => state.mealPlan);
  const mealTypes = useSelector((state) => state.app_options?.meal_types_min);
  const [searchTerm, setSearchTerm] = useState('');
  const [category, setCategory] = useState('');
  const [activeTab, setActiveTab] = useState('');
  const { category_url } = useParams();

  const [calories_filter, setCalorieFilter] = useState('');
  const [date_filter, setDateFilter] = useState('');

  useEffect(() => {
    if (newly_added_nutrition_plans_meal != '') {
      navigate('/customize-meal/'+newly_added_nutrition_plans_meal);
    }
  }, [newly_added_nutrition_plans_meal]);

  useEffect(() => {
    dispatch(clearMessage());
  }, []);

  useEffect(() => {
    const id = searchById(mealTypes, category_url);
    setCategory(id || '');
    setActiveTab(id || '');
    const params = { category: id || '', term: '', page: 1, perPage: 10, calories_filter:calories_filter, date_filter:date_filter };
    dispatch(fetchAddMealList(params));
  }, [category_url, mealTypes, dispatch]);

  const searchById = (dataArray, searchString) => {
    if (!searchString) return '';
    const lowerCaseSearchString = searchString.toLowerCase();
    const result = dataArray
      ?.filter(item => item.title.toLowerCase().includes(lowerCaseSearchString))
      .map(item => item.id);
    return result?.length > 0 ? result[0] : '';
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    const params = { category: activeTab === 'All' ? '' : category, term: e.target.value, page: 1, perPage: 10, calories_filter:calories_filter, date_filter:date_filter };
    dispatch(fetchAddMealList(params));
  };

  const handleToggleFavourite = async (id) => {
    try {
      await dispatch(toggleFavourite({ id, category, addMealListCurrentPage }));
    } catch (error) {
      console.error("Failed to toggle favourite:", error);
    }
  };

  const handleCategoryClicked = (tab) => {
    const id = tab === 'All' ? '' : tab;
    setActiveTab(tab);
    setCategory(id);
    const params = { category: id, term: searchTerm, page: 1, perPage: 10, calories_filter:calories_filter, date_filter:date_filter };
    dispatch(fetchAddMealList(params));
  };

  const handlePageChange = (page) => {
    const params = { category: activeTab === 'All' ? '' : category, term: searchTerm, page, perPage: 10, calories_filter:calories_filter, date_filter:date_filter };
    dispatch(fetchAddMealList(params));
  };

  const addMeal = (mealId) => {
    var c = category_url.toLowerCase();
    dispatch(addMealToNutritionPlan({ id: mealId, category:c }))
      .unwrap()
      .then(() => {
        navigate('/meal-plan');
      })
      .catch((error) => {
        console.error("Failed to add meal:", error);
      });
  };

  const addCustomizeMeal = (mealId) => {
    var c = category_url.toLowerCase();
    dispatch(addMealToNutritionPlan({ id: mealId, category:c }))
      .unwrap()
      .then(() => {
      })
      .catch((error) => {
        console.error("Failed to add meal:", error);
      });
  };

  const handleFilterChange = (type, value) => {
  if (type === "calories") {
    setCalorieFilter(value);
    setDateFilter('');
    const params = { category: activeTab === 'All' ? '' : category, term: searchTerm, page: 1, perPage: 10, calories_filter:value, date_filter:'' };
    dispatch(fetchAddMealList(params));
  } else if (type === "date") {
    setDateFilter(value);
    setCalorieFilter('');
    const params = { category: activeTab === 'All' ? '' : category, term: searchTerm, page: 1, perPage: 10, calories_filter:'', date_filter:value };
    dispatch(fetchAddMealList(params));
  }

   
};



  return (
    <Layout>
      <main className="main page-add-meal">
        <header className="main-head flex justify-between align-center">
          <div className="plus-wrapper">
            <h1 className="greet-user-text">Add Meal to {category_url}</h1>
            <Link to={`/recipes/${category_url}`} className="btn-save-meal recipies_btn" style={{ marginLeft: "15px" }}>Recipes</Link>
          </div>
          <div className="ms-auto">
            <Back />
          </div>
        </header>

        <div className="main-content flex justify-between flex-col-rev-mob pt-0">
          <div style={{ width: '100%' }}>
            <div className="meals-container meals-added pt-0">
              <div className="search-input">
   <div className="search-filters-container">
  {/* 🔍 Search */}
  <div className="form-group position-relative" style={{ margin: 0 }}>
    <input
      id="search"
      type="text"
      placeholder="Search"
      value={searchTerm}
      onChange={handleSearchChange}
    />
    <i className="fa-solid fa-magnifying-glass position-absolute"></i>
  </div>

  {/* --- FILTERS SECTION --- */}
  <div className="filters-wrapper">
    <div className="filters-card">
      {/* Calories Filter */}
      <div className="filter-item">
        <label htmlFor="calorieFilter">
          <i className="fa-solid fa-fire-flame-curved text-orange-500"></i>
          Sort by calories
        </label>
        <select id="calorieFilter" className="filter-dropdown"
        value={calories_filter}
        onChange={(e) => handleFilterChange("calories", e.target.value)}
        >
          <option value="default">⚪ Default</option>
          <option value="asc">⬆️ Lowest → Highest</option>
          <option value="desc">⬇️ Highest → Lowest</option>
        </select>
      </div>

      {/* Date Filter */}
      <div className="filter-item">
        <label htmlFor="dateFilter">
          <i className="fa-solid fa-clock text-blue-500"></i>
          Sort by added date
        </label>
        <select id="dateFilter" className="filter-dropdown"
         value={date_filter}
        onChange={(e) => handleFilterChange("date", e.target.value)}>
          <option value="default">⚪ Default</option>
          <option value="desc">🆕 Newest → Oldest</option>
          <option value="asc">📜 Oldest → Newest</option>
        </select>
      </div>
    </div>
  </div>
</div>





                <br />
                <div className="tags_container">
                  <Link
                    className={activeTab == 'All' ? 'active-category' : ''}
                    onClick={() => handleCategoryClicked('All')}
                  >
                    All
                  </Link>
                  {mealTypes?.map(type => (
                    <Link
                      key={type.id}
                      className={activeTab === type.id ? 'active-category' : ''}
                      onClick={() => handleCategoryClicked(type.id)}
                    >
                      {type.title}
                    </Link>
                  ))}
                  <Link
                    className={activeTab === 'favourite' ? 'active-category' : ''}
                    onClick={() => handleCategoryClicked('favourite')}
                  >
                    My Favourites
                  </Link>
                </div>
              </div>

              <div className="card responsive-table-container mt-4 p-0">
                <table className="admin-table table-add-meal">
                  <thead>
                    <tr>
                      <th style={{ width: '120px' }}>&nbsp;</th>
                      <th>Name</th>
                      <th>Calories</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addMealList?.length > 0 ? addMealList.map(meal => (
                      <tr key={meal.id}>
                        <td>
                          <div
                            style={{
                              width: '80px',
                              height: '80px',
                              backgroundColor: '#000',
                              borderRadius: '15px',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundImage: `url(${meal.meal_picture_full_url || 'default-image.png'})`,
                            }}
                          ></div>
                        </td>
                        <td>
                          {meal.meal_name}
                          <div className="d-md-none">
                            <div className="edit-delete-container">
                              <div>
                                <i
                                  className={`bi ${meal.favourite ? 'bi-heart-fill' : 'bi-heart'} text-red cursor-pointer fs-30`}
                                  onClick={() => handleToggleFavourite(meal.id)}
                                ></i>
                              </div>
                              <div>
                                <span className="reset-training" onClick={() => addMeal(meal.id)}>Add Meal</span>
                              </div>
                              <div>
                                <span className="reset-training cust" onClick={() => addCustomizeMeal(meal.id)}>Add & Customize</span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>{formatNumber(calculateCalories(meal.ingredients))}</td>
                        <td className="d-none-mobile">
                          <div className="edit-delete-container">
                            <div>
                              <i
                                className={`bi ${meal.favourite ? 'bi-heart-fill' : 'bi-heart'} text-red cursor-pointer fs-30`}
                                onClick={() => handleToggleFavourite(meal.id)}
                              ></i>
                            </div>
                            <div>
                              <span className="reset-training" onClick={() => addMeal(meal.id)}>Add Meal</span>
                            </div>
                            <div>
                              <span className="reset-training cust" onClick={() => addCustomizeMeal(meal.id)}>Add & Customize</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="4" style={{ textAlign: 'center' }}>No meals found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                currentPage={addMealListCurrentPage}
                totalPages={addMealListTotalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};
export default AddMeal;